module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright",
    attrs: {
      "id": "ch00_fm03_copy"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEW YORK UNIVERSITY PRESS")]), _c('br'), _vm._v("New York and London"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2006 by New York University"), _c('br'), _vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging–in–Publication Data"), _c('br'), _vm._v("Young, Alfred Fabian, 1925–"), _c('br'), _vm._v("Liberty tree: ordinary people and the American"), _c('br'), _vm._v("Revolution / Alfred F. Young."), _c('br'), _vm._v("p. cm."), _c('br'), _vm._v("Includes bibliographical references and index."), _c('br'), _vm._v("ISBN–13: 978–0–8147–9685–6 (cloth: alk. paper)"), _c('br'), _vm._v("ISBN–10: 0–8147–9685–0 (cloth: alk. paper)"), _c('br'), _vm._v("ISBN–13: 978–0–8147–9686–3 (pbk.: alk. paper)"), _c('br'), _vm._v("ISBN–10: 0–8147–9686–9 (pbk.: alk. paper)"), _c('br'), _vm._v("1. United States—History—Revolution, 1775–1783—Social"), _c('br'), _vm._v("aspects. 2. Radicalism—United States—History—18th"), _c('br'), _vm._v("century. I. Title."), _c('br'), _vm._v("E.209.Y68  2006"), _c('br'), _vm._v("973.3—dc22           2006008340")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("New York University Press books are printed on acid-free paper,"), _c('br'), _vm._v("and their binding materials are chosen for strength and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("c 10 9 8 7 6 5 4 3 2 1"), _c('br'), _vm._v("p 10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b740d32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03_copy.vue
// module id = 66
// module chunks = 0